import { Grid, MenuItem, TextField, Typography } from '@mui/material'
import { type Control, Controller } from 'react-hook-form'

import { Box } from '@/components/ui'
import { isTaxRatePercentValid } from '@/utils/taxRateUtils'

import {
  type CreateOrgFormValues,
  TAX_TYPE_OPTIONS,
} from '../definitions/createOrganizationForm'

interface BillingTaxStepProps {
  control: Control<CreateOrgFormValues>
}

export const BillingTaxStep = ({ control }: BillingTaxStepProps) => (
  <Box variant='flexColumn' gap='md'>
    <Typography variant='body2' color='text.secondary'>
      All optional — the practice can fill these in later from its own settings.
    </Typography>
    <Grid container spacing={2}>
      <Grid size={6}>
        <Controller
          name='federal_tax_id'
          control={control}
          render={({ field }) => (
            <TextField {...field} label='Tax ID' placeholder='12-3456789' fullWidth />
          )}
        />
      </Grid>
      <Grid size={6}>
        <Controller
          name='federal_tax_type'
          control={control}
          render={({ field }) => (
            <TextField {...field} label='Tax ID Type' select fullWidth>
              <MenuItem value=''>
                <em>Not set</em>
              </MenuItem>
              {TAX_TYPE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
      </Grid>
    </Grid>
    <Controller
      name='tax_rate'
      control={control}
      rules={{
        validate: (value) =>
          isTaxRatePercentValid(value) ||
          'Enter a percentage up to two whole digits and three decimal places, e.g. 8.5.',
      }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label='Tax Rate (%)'
          placeholder='8.5'
          fullWidth
          error={fieldState.invalid}
          helperText={
            fieldState.error?.message ??
            'Percentage — enter 8.5 for 8.5%, up to three decimal places.'
          }
        />
      )}
    />
  </Box>
)
